function svgPin( color ) {
    return '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 36" width="25" height="38">'
        + '<path d="M12 0C5.373 0 0 5.373 0 12c0 8 12 24 12 24S24 20 24 12C24 5.373 18.627 0 12 0z" fill="' + color + '" stroke="gray" stroke-width="1.2" stroke-linejoin="round"/>'
        + '<circle cx="12" cy="12" r="5" fill="white"/>'
        + '</svg>';
}
function creaMarcador( latLong, icono, zIndex, url, color ) {
    var svg = svgPin( color );
    if ( google.maps.marker && google.maps.marker.AdvancedMarkerElement ) {
        var div = document.createElement( 'div' );
        div.innerHTML = svg;
        div.style.transform = 'translate(-50%, -100%)';
        var adv = new google.maps.marker.AdvancedMarkerElement( {
            position: latLong,
            map: map,
            content: div,
            placeUrl: url,
            zIndex: zIndex
        } );
        adv.setMap = function ( mapa ) { adv.map = mapa; };
        return adv;
    }
    return new google.maps.Marker( {
        position: latLong,
        map: map,
        icon: {
            url: 'data:image/svg+xml,' + encodeURIComponent( svg ),
            scaledSize: new google.maps.Size( 25, 38 ),
            anchor: new google.maps.Point( 14, 42 ),
            labelOrigin: new google.maps.Point( 14, 56 )
        },
        placeUrl: url,
        animation: google.maps.Animation.DROP,
        zIndex: zIndex
    } );
}
function agregaMarca( latLong, iconType, url, color = '#d4148e' ) {
    var icono = iconType == 1 ? 'mapmarker.png' : 'mapmarkergris.png';
    marcaActual = creaMarcador( latLong, icono, 99, url, color );
    if ( url !== '' ) {
        if ( google.maps.marker && google.maps.marker.AdvancedMarkerElement && marcaActual.content ) {
            marcaActual.content.style.cursor = 'pointer';
            marcaActual.content.addEventListener( 'click', function() {
                window.location.href = this.placeUrl;
            } );

        } else {
            marcaActual.addListener( 'click', function() {
                window.location.href = this.placeUrl;
            } );
        }
    }
    markers.push( marcaActual );
}
function cargarMarcas( mapa ) {
    for ( var i = 0; i < markers.length; i++ ) {
        markers[ i ].setMap( mapa );
    }
}
function limpiarMarcas() {
    cargarMarcas( null );
    markers = [];
    marcaActual = null;
    if ( directions != null ) { directions.setMap( null ); directions = null; }
}
function asignaUbicacion( latitude, longitude ) {
    seteaSesion( 'latitud', latitude );
    seteaSesion( 'longitud', longitude );
}
function iniciaMapa( latitude, longitude, url, color = '#d4148e' ) {
    latitude = parseFloat( latitude );
    longitude = parseFloat( longitude );
    if ( isNaN( latitude ) || isNaN( longitude ) ) { return; }
    var latLong = new google.maps.LatLng( latitude, longitude );
    var mapOptions = {
        center: latLong,
        zoom: 13,
        streetViewControl: false,
        gestureHandling: 'cooperative'
    };
    map = new google.maps.Map( document.getElementById( 'mapa' ), mapOptions );
    agregaMarca( latLong, 1, url, color );
}
function ajustaCentro( newLat, newLng, url, color = '#d4148e' ) {
    newLat = parseFloat( newLat );
    newLng = parseFloat( newLng );
    if ( isNaN( newLat ) || isNaN( newLng ) || typeof map === 'undefined' || !map ) { return; }
    limpiarMarcas();
    map.setCenter( { lat: newLat, lng: newLng } );
    map.setZoom( 13 );
    var latLong = new google.maps.LatLng( newLat, newLng );
    agregaMarca( latLong, 1, url, color );
}
function rutaNavegacion() {
    navigator.geolocation.getCurrentPosition( cargaRuta, function() {
        let msg = idioma === 'ES' ? 'No se pudieron obtener las coordenadas para mostrar la ruta, por favor asegúrate de que tu dispositivo tenga activada la ubicación y vuelve a intentarlo.' : 'Unable to obtain coordinates to display the route, please make sure your device has location enabled and try again.';
        alerta( msg, 'error', false );
    } );
}
function cargaRuta( position ) {
    console.log( position );
    verRutaMapa( position.coords.latitude, position.coords.longitude, 1 );
}
function verRutaMapa( lat, long, tipo ) {
    var inicio = new google.maps.LatLng( obtenSesion( 'latitud' ), obtenSesion( 'longitud' ) );
    var fin = new google.maps.LatLng( lat, long );
    limpiarMarcas();
    if ( marcaActual != null ) {
        marcaActual.setMap( null );
        marcaActual = null;
    }
    var tipoTravel;
    switch ( tipo ) {
        case 1: tipoTravel = google.maps.TravelMode.DRIVING; break;
        case 2: tipoTravel = google.maps.TravelMode.BICYCLING; break;
        case 3: tipoTravel = google.maps.TravelMode.TRANSIT; break;
        case 4: tipoTravel = google.maps.TravelMode.WALKING; break;
        default: tipoTravel = google.maps.TravelMode.DRIVING; break;
    }
    directionsService = new google.maps.DirectionsService();
    directions = new google.maps.DirectionsRenderer();
    directions.setOptions( { suppressMarkers: true } );
    directions.setMap( map );
    directionsService.route( {
        origin: inicio,
        destination: fin,
        travelMode: tipoTravel
    }, function ( response, status ) {
        if ( status === google.maps.DirectionsStatus.OK ) {
            directions.setDirections( response );
        } else {
            console.log( 'Error en comunicacion del mapa por: ' + status );
        }
    } );
    agregaMarca( inicio, 1, '' );
    agregaMarca( fin, 2, '' );
}